
import { defineComponent, computed, ref } from "@vue/runtime-core";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading, mdiOpenInNew, mdiPlusBox, mdiReceipt, mdiTextBoxOutline, mdiEmailFast } from "@mdi/js";
import { useStore as useOrderStore } from "@/stores/order";
import { Inertia } from "@inertiajs/inertia";
import { useStore } from "@/stores/main";

export default defineComponent({
  setup() {
    const orderStore = useOrderStore();
    const store = useStore();

    const isPayed = computed(() => orderStore.isPayed);
    const isInvoiced = computed(() => orderStore.isInvoiced);

    const invoiceUrl = computed(() => {
      return `/cash-till/print-order/${orderStore.order_id}/`;
    });

    const invoiceEmailUrl = computed(() => {
      return `/cash-till/email/${orderStore.order_id}`;
    });

    const receiptLoading = ref(false);

    const printReceipt = () => {
      receiptLoading.value = true;
      Inertia.post(route("orders.receipt.print", { order: orderStore.order_id }), {}, {
        preserveScroll: true,
        onFinish: () => {
          receiptLoading.value = false;
        }
      });
    };

    return {
      isPayed,
      isInvoiced,
      invoiceUrl,
      receiptLoading,
      printReceipt,
      invoiceEmailUrl,
      isAdmin: computed(() => store.isAdmin),
      clientEmail: computed(() => orderStore.order?.client_model?.email),
      receiptIcon: mdiReceipt,
      loadingIcon: mdiLoading,
      invoiceIcon: mdiTextBoxOutline,
      newIcon: mdiPlusBox,
      emailIcon: mdiEmailFast,
      externalIcon: mdiOpenInNew,
    };
  },
  components: { Button, SvgIcon }
});
